import * as React from 'react';
import ZiInter from 'src/helper/RoleAndPermission/ZiInter';
import Auth from 'src/service/Auth';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import AxiosIndicatorRunTimeLoader from 'src/component/AxiosIndicatorRunTimeLoader';
import { __remove, __set } from 'src/store/axios_indicator';
import { useState } from 'react';
import ReusableDiv from 'src/support/ReusableDiv';

const ContactUsPopup = (props) => {
    const { SetStatus, data } = props;
    const [internalUsers, setInternalUsers] = useState([])
    const [loader, setLoader] = useState(true)
    const [__check] = useAxiosIndicatorCheck();

    const validateRestrictOrderBlock = () => {
        if ((data.restrict != undefined && data.restrict) || data.order_block) {
            return true;
        }
        return false;
    }

    React.useEffect(() => {
        const getCustomerInformation = async () => {
            let res = await new Auth().getCustomerScopedInformation();
            setLoader(false);
            if (res?.data?.user_data?.filter(x => x.type === ZiInter.avUserInfoName).length > 0) {
                setInternalUsers(res?.data?.user_data?.filter(x => x.type === ZiInter.avUserInfoName));
            }
        }
        // if (!isValid || (isValid && data.order_block)) {
        getCustomerInformation();
        // }

        if(data?.restrict && !data.order_block)
        {
            setLoader(false);
        }
    }, []);


    const validateSupportTeam = () => {
        if (data?.restrict && !data.order_block || internalUsers?.length === 0) {
            return true;
        }
        return false;
    }

    const validateISR = () => {
        if ((!isValid || data?.order_block) && internalUsers?.length > 0) {
            return true;
        }
        return false;
    }

    const isValid = validateRestrictOrderBlock();
    return (
        <>
            <div className="avnet-modal modal-680">
                <div className="avnet-modal-inner">
                    {/* Modal Header */}
                    <button type="button" className="close py-3" data-dismiss="modal"
                        onClick={() => {
                            SetStatus(false)
                        }}>×
                    </button>
                    <div className="modal-header justify-content-center mt-0">
                        <h3 className="pcn-modal-heading pl-5">General Support</h3>
                    </div>
                    {/* Modal body */}
                    <div className="modal-body py-0">
                        <div className="clearfix" />
                        <div className="mt-3 mb-5">
                            {loader ? <AxiosIndicatorRunTimeLoader /> :
                                <>
                                    {/**
                                     * Ticket    : 9327 
                                     * Change    : Type mistake for permission
                                     * Change by : Pankaj
                                     * Date      : 21 Feb 2023 
                                    */
                                    }
                                    {validateISR() ? ReusableDiv.ContactUsPopUpHeaderText('Please contact your local Sales Representative.') :
                                        validateSupportTeam() && ReusableDiv.ContactUsPopUpHeaderText('Please contact support team.')
                                    }

                                    {validateSupportTeam() &&
                                        <div className='mb-3 ms-4'>
                                            {ReusableDiv.ContactUsPopUpBodyText('', '')}
                                        </div>
                                    }

                                    {validateISR() && internalUsers?.map((x, i) => (
                                        <>
                                            <div className='mb-3 ms-4'>
                                                <p className='mb-0'><strong>{x?.first_name} {x?.last_name}</strong> (Internal Sales Representative)</p>
                                                {ReusableDiv.ContactUsPopUpBodyText(x?.communication?.phone, x?.communication?.email)}
                                            </div>
                                        </>
                                    ))

                                    }
                                </>
                            }
                        </div>
                    </div>
                    {/* Modal footer */}
                    <div className="modal-footer text-center">
                        <div className="modal-footer-actions">
                            <button type="button" className={isValid ? "bs5 btn btn-sm btn-primary" : "bs5 btn btn-secondary btn-sm"} data-dismiss="modal"
                                onClick={() => {
                                    SetStatus(false)
                                }}>
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ContactUsPopup;